<div class="main-content">
  <div class="container-fluid">
    <div class="row" id="loginContainer">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Admin access required</h4>
          </div>
          <div class="card-body">
            <p>
              @if (signedInEmail) {
                <strong>{{ signedInEmail }}</strong> doesn't have admin access yet.
              } @else {
                This Google account doesn't have admin access yet.
              }
            </p>
            <p>Ask an existing admin to grant you access from the user management page, then try again.</p>
            <button mat-raised-button type="button" (click)="tryDifferentAccount()" class="btn btn-danger">
              <mat-icon>swap_horiz</mat-icon>
              Try a different account
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
